export const gridBreakpoints = {
  breakpoint: {
    xs: 360,
    sm: 548,
    md: 800,
    lg: 1060,
    xl: 1320,
  },
}
